module.exports = __webpack_public_path__ + "img/ca-5.014c00df.jpg";